const MOBILE_APP_USER_AGENT = "OnTheClockNowMobile";

export function isNativeMobileApp() {
  return (
    typeof navigator !== "undefined" &&
    navigator.userAgent.includes(MOBILE_APP_USER_AGENT)
  );
}
